export const initIntercom = (profile, locale, orga_id = null, event_id = null) => {
    if (window.Intercom) return;

    // Old accounts still have profile.data structure,
    // while newer accounts (Keycloak migration) expose profile directly
    let fullName = '';

    if (profile?.data) {
        const { firstname, name } = profile.data;
        fullName = `${firstname || ''} ${name || ''}`.trim();
    } else {
        fullName = profile?.name || '';
    }

    window.intercomSettings = {
        app_id: 'tyoj39m1',
        language_override: locale,
        name: fullName,
        'Organiser ID': Number(orga_id),
        ...(event_id && { 'Event ID': Number(event_id) })
    };

    const s = document.createElement('script');
    s.async = true;
    s.src = `https://widget.intercom.io/widget/${window.intercomSettings.app_id}`;
    document.body.appendChild(s);
};
